import { searchInputVariants } from '@web/modules/core'
import React, { useEffect, useState } from 'react'
import { Button, Input, Loading } from '@tecsinapse/cortex-react'
import { IoSearchOutline } from 'react-icons/io5'

interface SearchInputProps {
  label?: string
  placeholder?: string
  value?: string
  isSubmitting?: boolean
  onChange?: (value: string) => void
  onClick?: (value: string) => void
}

const { inputFace } = searchInputVariants()

const SearchInput = ({ label, placeholder, value = '', isSubmitting = false, onChange, onClick }: SearchInputProps) => {
  const [bouncedText, setBouncedText] = useState<string>(value)

  useEffect(() => {
    if (onChange) {
      onChange(bouncedText)
    }
    // add onChange dep = infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bouncedText])

  const handleEnterKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onClick && bouncedText.length > 3) {
      onClick(bouncedText)
    }
  }

  return (
    <div className='flex flex-row w-full space-x-mili'>
      <Input.Search
        variants={{ className: inputFace() }}
        placeholder={placeholder}
        label={label}
        onChange={event => setBouncedText(event.target.value)}
        onKeyDown={handleEnterKey}
        disabled={isSubmitting}
        defaultValue={value}
      />

      {onClick && (
        <Button
          className='h-11'
          variants={{
            intent: 'primary',
            size: 'square'
          }}
          onClick={() => onClick(bouncedText)}
          disabled={bouncedText.length < 3 || isSubmitting}
        >
          <div className={'flex'}>{isSubmitting ? <Loading /> : <IoSearchOutline className={'text-centi'} />}</div>
        </Button>
      )}
    </div>
  )
}

export default SearchInput
